import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.petsuitesGreen,
  fontColor: colors.graphite,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default promoBanner;